module.exports = __webpack_public_path__ + "static/img/listempty.ec1260ce.png";